module.exports = __webpack_public_path__ + "static/media/planet-proof.4cd15d27.svg";